export default "__VITE_ASSET__Bo$OIHFl__"